<template >
  <!-- modal -->


  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>

    <div
        style="position: absolute; right: 28vw; width: 51vw; height: auto"
        class="card-panel-main col-lg-9 mb-5 p-2"
    >

      <div v-if="!modalActive" class="card card-body card-panel-box border-0">
        <div class="d-flex align-items-center justify-content-between gap-3">
          <div class="d-flex align-items-start gap-1vw">
            <div class="rounded-circle bg-info w-1vw h-1vw mt-3"></div>
            <div>
              <p class="fw-bold mb-0 fs-1-4vw text-end">
                <span>تیکت</span>: <span> {{item_ticket.title}}</span>
                <span>/</span><span> شماره:</span> <span>{{item_ticket.code}} </span>
              </p>
              <p class="text-muted mb-0">سیستم درخواست پشتیبانی تیکت</p>
            </div>
          </div>
          <div @click="$router.go(-1)"
               class="bg-info mainHover rounded-0-4vw d-flex align-items-center justify-content-center gap-01vw text-white fw-bold cursor-pointer py-1 px-3"
          >

            <p class="mb-0">برگشت  </p>
          </div>
        </div>

        <!-- table -->
          <hr>

          <div  class="mt-5 d-flex flex-column h-auto mb-3 mx-0 g-4 card bg-white p-3" >

            <div class="col-12">
              <label class="text-end mb-3 d-block fw-bold">توضیحات</label>
              <textarea v-model="description" style="height: 10vw;" rows="17" class="form-control"></textarea>
            </div>
            <div class="col-12 position-relative">
              <label class="text-end mb-3 d-block fw-bold">پیوست فایل</label>
              <span @click.prevent="selectFile" class="position-absolute">انتخاب فایل</span>
              <input ref="fileInput" type="file" class="d-block form-control" @change="handleFileChange" />
              <div v-if="showProgress" class="progress mt-3">
                <div class="progress-bar" role="progressbar" :style="{ width: uploadProgress + '%' }" :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">{{ uploadProgress }}%</div>
              </div>
            </div>
            <div class="col-2 mx-auto">
              <p @click="submitTicket" class="btn btn-primary btn-submit-1 mt-3">ثبت تیکت</p>
            </div>
          </div>
        <hr>
        <div v-for="(item,index) in all_items" class="card w-100 mt-3 p-4 h-auto">
          <div class="d-flex justify-content-between">
           <p> {{item.user.firstname}} {{item.user.lastname}}</p>
            <p>{{item.change_date}}</p>
          </div>
          <hr>
          <div class="card-body text-end">
            {{item.description}}
          </div>
         <center v-if="item.file">
          <hr>
           <a  target="_blank" class="btn btn-submit-1 btn-primary mt-2" :href="`${this.download_url}/${item.file}`">دانلود پیوست</a>
         </center>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import Modal from "@/components/Modal/Modal.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "HomeView",
  data() {
    return {
      modalActive:false,
      is_update: false,
      title: '',
      priority: '',
      description: '',
      selectedFile: null,
      uploadProgress: 0,
      showProgress: false,
      all_items: [],
      items_closed: 0,
      items_answered: 0,
      items_under_review: 0,
      items_not_reviewed: 0,
      items_waiting_response: 0,
      item_ticket: []
    };
  },
  components: {
    Modal,
    Reset,
    Sidebar,
    splash,
  },
  methods: {
    setPriority(item){
      if (item==='low'){
        return 'کم'
      }else if (item==='medium'){
        return 'متوسط'

      }else{
        return 'زیاد'

      }
    },setStatus(item){
      if (item==='closed'){
        return 'بسته شده'
      }else if (item==='answered'){
        return ' پاسخ داده شده'

      }else if (item==='under_review'){
        return 'در حال بررسی'

      }else if (item==='not_reviewed'){
        return 'بررسی نشده'

      }else if (item==='waiting_response'){
        return 'منتظر پاسخ شما'

      }
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    submitTicket() {


      const formData = new FormData();
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);

      }
      formData.append('title', this.title);
      formData.append('description', this.description);
      formData.append('priority', this.priority);
      formData.append('parent_id', this.$route.params.id);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.base_url}/Tickets/store`, true);
      xhr.setRequestHeader('Authorization', `Bearer ${this.$cookies.get('token')}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);
          this.showProgress = true;
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          toast.success('با موفقیت ثبت شد!');
          // Reset progress bar and form
          this.uploadProgress = 0;
          this.showProgress = false;
          this.title = '';
          this.priority = '';
          this.description = '';
          this.selectedFile = null;
          this.$refs.fileInput.value = null;
          this.modalActive = false
          this.all()

        } else {
          toast.success('خطایی رخ داده است');
        }
      };

      xhr.onerror = () => {
        toast.error('خطایی در ارسال فایل رخ داده است');
      };

      xhr.send(formData);
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push("/mother_items");
        return;
      }
    },
    toggleModal() {
      this.modalActive = !this.modalActive;
    },
    all() {
      fetch(`${this.base_url}/Tickets/show/${this.$route.params.id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({}),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.all){
              this.all_items = [...response.all]
            }
            this.item_ticket = response.item



          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.all()
  }
};
</script>
<style scoped lang="scss">
.fade-enter-active,.fade-leave-active{
  transition: opacity 0.6s;
}
.fade-enter-from,.fade-leave-to{
  opacity: 0;
}
a {
  font-size: 1vw;
}
.card:not(:last-child) {
  height: 12vw;
}
.btn-submit-1 {
  width: 18vw !important;
}
/*.line_after{
    position: relative;
    &::after{
      position: absolute;
      width: 0.01vw;
      height: 53vw;
      content: '';
      background-color: #efecf3 !important;
      top: 5vw;
      right: 35.3vw ;
      border-radius: 1vw;
    }
  }*/
p {
  font-size: 1vw;
}
.position-absolute{
  right: 1.1vw;
  background-color: #fff;
  top: 2.7vw;
  cursor: pointer;
  font-size: 1vw;
}
img:hover{
  filter: unset;
  cursor: pointer;
}
</style>